<template>
  <div>
    <div class="creative-lite">
      <p class="title-name">{{ title }}</p>
      <div class="form-item-contaier">
        <div class="add-btn">
          <button
            type="button"
            class="btn"
            :class="{ disabled }"
            @click="handleShow"
          >
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_play.png')"
              fit="cover"
            ></el-image
            >添加视频
          </button>
          <button
            type="button"
            class="btn"
            :class="{ disabled }"
            style="margin-left: 16px"
            v-if="isSearch"
          >
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_img.png')"
              fit="cover"
            ></el-image
            >添加图片
          </button>
          <span class="num-tip">已选 {{ videoNum }} / {{ videoMax }}</span>
          <button type="button" class="btn right" :class="{ disabled }">
            <el-image
              class="icon"
              :src="
                require(`@/assets/images/simulation/icon_${
                  videoMax == 7 ? 'create' : 'clip'
                }.png`)
              "
              fit="cover"
            ></el-image
            >{{ rightBtn }}
            <el-image
              class="r-icon"
              v-if="videoMax == 10"
              :src="require('@/assets/images/simulation/icon_new.png')"
              fit="cover"
            ></el-image>
          </button>
        </div>
        <div class="empty-material" v-if="videoNum == 0">
          <el-image
            style="margin-top: 30px; width: 100px; height: 72px"
            :src="require('@/assets/images/simulation/empty.png')"
            fit="cover"
          ></el-image>
          <p class="text">
            {{ disabled ? "还未添加商品，请先添加商品" : "还没添加创意素材~" }}
          </p>
        </div>
        <div class="card-list" v-else>
          <div class="creative-item-search" v-if="isSearch">
            <i class="el-icon-error" @click="handleDel"></i>
            <div class="left-img">
              <div class="img-box">
                <p class="type-text">竖版视频</p>
                <el-image
                  style="width: 86px; height: 131px; vertical-align: top"
                  :src="require('@/assets/images/simulation/video_cover.jpg')"
                  fit="cover"
                ></el-image>
              </div>
              <button type="button" class="change-cover-btn">
                换视频 | 换封面
              </button>
            </div>
            <div class="right-form-container">
              <p class="title">创意标题</p>
              <el-input
                class="t-input"
                type="text"
                size="small"
                placeholder="请输入创意标题，不少于5个字"
                v-model="originalityTitle"
                maxlength="55"
                show-word-limit
              />

              <p class="title mt">推广卡片</p>
              <div style="width: 456px">
                <div class="promotion-card">
                  <el-image
                    style="width: 34px; height: 34px"
                    :src="require('@/assets/images/simulation/video_cover.jpg')"
                    fit="cover"
                  ></el-image>
                  <div class="right-info">
                    <p>视频同款商品</p>
                    <p class="s">高档时尚舒适又减龄</p>
                  </div>
                  <span class="card-button">查看详情</span>
                </div>
                <span class="change-text">更改</span>
              </div>
            </div>
          </div>

          <div class="creative-item" v-else>
            <i class="el-icon-error" @click="handleDel"></i>
            <div class="left-img">
              <div class="img-box">
                <p class="type-text">竖版视频</p>
                <el-image
                  style="width: 86px; height: 131px; vertical-align: top"
                  :src="require('@/assets/images/simulation/video_cover.jpg')"
                  fit="cover"
                ></el-image>
              </div>
              <button type="button" class="change-cover-btn">更换封面</button>
            </div>
            <div class="right-form-container">
              <p class="title">创意标题</p>
              <el-input
                type="textarea"
                placeholder="请输入创意标题，不少于5个字"
                v-model="originalityTitle"
                maxlength="55"
                show-word-limit
                resize="none"
                :autosize="{ minRows: 4, maxRows: 4 }"
              />
            </div>
          </div>
        </div>
      </div>

      <template v-if="isSearch">
        <p class="tips" v-if="videoNum > 0">
          <i class="el-icon-info"></i>
          建议添加至少 3
          个创意并开启「动态创意」来实现更多创意组合，有机会获得更多流量
        </p>
      </template>
    </div>

    <el-drawer
      class="drawer"
      :size="840"
      :visible.sync="showAddVideo"
      :with-header="false"
    >
      <p class="title">我的视频</p>

      <div class="video-item" @click="videoActive = !videoActive">
        <div class="video-wrapper" :class="{ active: videoActive }">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('@/assets/images/simulation/video_cover.jpg')"
            fit="cover"
          ></el-image>
          <span class="time">00:21</span>
          <i class="el-icon-caret-right icon"></i>
        </div>
        <p class="video-name">v02006g10000c89l89rc77udctv63l60</p>
      </div>

      <div class="foot">
        <p style="float: left; margin-top: 8px">
          已选{{ videoActive ? 1 : 0 }}/1
        </p>
        <div class="right-btns">
          <button
            type="button"
            class="btn next"
            :class="{ disabled: !videoActive }"
            @click="handleConfirm"
            :disabled="!videoActive"
          >
            确定
          </button>
          <button type="button" class="btn" @click="showAddVideo = false">
            取消
          </button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    videoNum: Number,
    videoMax: Number,
    title: String,
    rightBtn: String,
    isSearch: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      showAddVideo: false,
      videoActive: false,
      originalityTitle: "领衫舒适休闲长袖t恤内搭",
    };
  },
  methods: {
    handleShow() {
      if (this.disabled) return;
      this.showAddVideo = true;
    },
    handleDel() {
      this.$emit("onConfirm", 0);
    },
    handleConfirm() {
      this.$emit("onConfirm", 1);
      this.showAddVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.creative-lite {
  margin-top: 32px;
  width: 648px;
  .title-name {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #333;
  }
  .form-item-contaier {
    margin-top: 12px;
    .add-btn {
      overflow: hidden;
      .btn {
        min-width: 100px;
        padding: 5px 16px;
        font-size: 14px;
        line-height: 22px;
        border-radius: 4px;
        color: #333;
        background-color: #fff;
        border: solid 1px #999;
        user-select: none;
        &:hover {
          background-color: #edf1fd;
          border-color: #194ce5;
        }
        &.right {
          float: right;
        }
        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
          &:hover {
            background-color: inherit;
            border-color: inherit;
          }
        }
        .icon {
          margin-right: 3px;
          width: 18px;
          height: 18px;
          vertical-align: -4px;
        }
        .r-icon {
          margin-left: 3px;
          vertical-align: -6px;
        }
      }
      .num-tip {
        margin-left: 16px;
        color: #999;
      }
    }
    .empty-material {
      margin-top: 16px;
      width: 647px;
      height: 180px;
      text-align: center;
      border: 1px solid #d0d3d9;
      border-radius: 4px;
      .text {
        margin-top: 10px;
        line-height: 22px;
        height: 22px;
        color: #999;
      }
    }
    .card-list {
      margin-top: 16px;
      .creative-item-search,
      .creative-item {
        position: relative;
        display: inline-block;
        margin-bottom: 16px;
        margin-right: 24px;
        padding: 16px;
        padding-left: 13px;
        width: 311px;
        border-radius: 4px;
        border: 1px solid #194ce5;
        border-left-width: 4px;
        cursor: pointer;
        &.creative-item-search {
          width: 100%;
          .change-cover-btn {
            padding: 0;
            font-size: 12px;
          }
          .right-form-container {
            margin-left: 24px;
            ::v-deep .t-input {
              width: 456px;
              .el-input__inner {
                background-color: #f2f2f2;
              }
              .el-input__count-inner {
                background: #f2f2f2;
              }
            }
            .promotion-card {
              display: inline-block;
              width: 240px;
              height: 48px;
              padding: 7px;
              background-color: #f0f0f0;
              border-radius: 4px;
              vertical-align: middle;
              .right-info {
                display: inline-block;
                margin-left: 5px;
                vertical-align: top;
                .s {
                  margin-top: 2px;
                  font-size: 10px;
                  line-height: 14px;
                  color: #999;
                }
              }
              .card-button {
                display: inline-block;
                height: 26px;
                width: 70px;
                margin-top: 4px;
                margin-left: 5px;
                background: #ed5085;
                border-radius: 2px;
                font-weight: 500;
                font-size: 13px;
                line-height: 26px;
                text-align: center;
                color: #fff;
                vertical-align: top;
              }
            }
            .change-text {
              display: inline-block;
              margin-left: 16px;
              font-size: 14px;
              line-height: 48px;
              height: 48px;
              color: #194ce5;
            }
          }
        }
        .el-icon-error {
          position: absolute;
          right: -13px;
          top: -13px;
          font-size: 26px;
          color: rgb(51, 51, 51);
        }
        .left-img {
          display: inline-block;
          width: 88px;
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #e0e0e0;
          .img-box {
            position: relative;
            .type-text {
              position: absolute;
              top: 4px;
              left: 4px;
              background: #000;
              border-radius: 4px;
              font-size: 12px;
              line-height: 22px;
              height: 22px;
              padding: 0 4px;
              color: #fff;
              z-index: 22;
            }
          }
          .change-cover-btn {
            width: 100%;
            height: 31px;
            text-align: center;
            background: #fff;
            &:hover {
              color: #194ce5;
            }
          }
        }
        .right-form-container {
          display: inline-block;
          width: 176px;
          margin-left: 13px;
          vertical-align: top;
          .title {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            height: 20px;
            color: #333;
            margin-bottom: 8px;
            &.mt {
              margin-top: 26px;
            }
          }
          ::v-deep  {
            .el-textarea {
              .el-textarea__inner {
                font-family: inherit;
              }
            }
          }
        }
      }
    }
  }
  .tips {
    margin: 4px 0;
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 12px;
    color: #333;
    .el-icon-info {
      margin-right: 5px;
      font-size: 16px;
      color: #969696;
      vertical-align: -1px;
    }
  }
}
::v-deep .drawer {
  .el-drawer__body {
    position: relative;
    padding: 16px 24px 0;
    color: #333;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #111;
    }
    .video-item {
      margin-top: 30px;
      cursor: pointer;
      .video-wrapper {
        position: relative;
        width: 180px;
        height: 270px;
        border-radius: 4px;
        overflow: hidden;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          background: #000;
          opacity: 0.3;
          z-index: 11;
        }
        &.active {
          border: 1px solid #194ce5;
          border-radius: 5px;
          &::before {
            content: "✔";
            position: absolute;
            top: 0;
            right: 0;
            width: 36px;
            height: 36px;
            text-align: center;
            letter-spacing: -12px;
            color: #fff;
            background-image: url("../../../../assets/images/simulation/triangle.svg");
            z-index: 22;
          }
        }
        .time {
          position: absolute;
          display: inline-block;
          top: 4px;
          left: 2px;
          padding: 0 3px;
          width: 40px;
          height: 22px;
          border-radius: 4px;
          background: #111;
          color: #fff;
          font-size: 12px;
          line-height: 22px;
          opacity: 0.88;
          z-index: 22;
        }
        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 50px;
          color: #fff;
          opacity: 0.8;
          z-index: 22;
        }
      }
      .video-name {
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        margin-top: 8px;
        width: 180px;
        height: 44px;
        color: #333;
        text-overflow: ellipsis;
        word-break: break-all;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        line-break: break;
        -webkit-line-clamp: 2;
      }
    }
  }
  .main {
    height: calc(100vh - 16px - 24px - 48px - 36px - 66px - 1px);
  }
  .foot {
    position: absolute;
    left: 0;
    bottom: 0;
    margin: 0;
    padding: 16px 24px;
    border-top: 1px solid #e5e5e5;
    width: 100%;
    height: 66px;
    background-color: #fff;
    overflow: hidden;
    .right-btns {
      overflow: hidden;
      .btn {
        float: right;
        min-width: 100px;
        padding: 5px 16px;
        border-radius: 4px;
        line-height: 22px;
        color: #333;
        background: #fff;
        border-color: #999;
        border: 1px solid #dcdde0;
        transition: all 0.3s ease;
        &:hover {
          background: #edf1fd;
          border-color: #194ce5;
        }
        &.next {
          margin-left: 8px;
          color: #fff;
          background: #1966ff;
          border: 1px solid transparent;
          &:hover {
            background: #4784ff;
          }
          &.disabled {
            color: #edf1fd;
            background-color: #98aff4;
            border-color: #98aff4;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>